/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamPosition = {
    properties: {
        team: {
            type: 'TeamListElement',
            isRequired: true,
        },
        playerPosition: {
            type: 'PlayerPosition',
            isRequired: true,
        },
    },
} as const;
